import { zodResolver } from '@hookform/resolvers/zod'
import { cn } from '@repo/tailwind-config/tailwind.functions'
import { FileTypeEnum } from '@repo/toolkit/types'
import { ImageIcon } from '@repo/ui/icons'
import { useForm } from 'react-hook-form'

import { TeflDiplomaInput } from '../../../lib/types/models/tefl-diploma/tefl-diploma-input'
import { BaseFormProps } from '../../../lib/types/utils'
import { getSubmitAction } from '../../../lib/utils/buttons-config/validation-buttons-config'
import { FORM_MODE } from '../../../utils/constants/form.constants'
import { Form, FormControl, FormField, FormItem } from '../../elements/forms/form'
import ControlledFileInput from '../../elements/inputs/controlled-file-input'
import ControlledInput from '../../elements/inputs/controlled-input'
import ValidationButtons from '../../elements/validation-buttons'
import { teflDiplomaFormSchema } from './utils'

type Props = BaseFormProps<TeflDiplomaInput, true> & {
  className?: string
}

const TeflDiplomaForm = ({ defaultValues, className, ...validationButtonProps }: Props) => {
  const form = useForm<TeflDiplomaInput>({
    resolver: zodResolver(teflDiplomaFormSchema),
    defaultValues,
    mode: FORM_MODE
  })

  return (
    <Form {...form}>
      <form
        onSubmit={form.handleSubmit(getSubmitAction(validationButtonProps.buttonsConfig))}
        className="flex flex-col gap-4"
      >
        <div className={cn('flex flex-row gap-3', className)}>
          <FormField
            control={form.control}
            name="name"
            render={({ field }) => (
              <FormItem className={'flex-1'}>
                <FormControl>
                  <ControlledInput
                    {...field}
                    required
                    type={'text'}
                    label={'Title of the diploma'}
                  />
                </FormControl>
              </FormItem>
            )}
          />
          <FormField
            control={form.control}
            name={'yearOfObtention'}
            render={({ field }) => (
              <FormItem className={'flex-1'}>
                <FormControl>
                  <ControlledInput {...field} required label={'Date of diploma'} type={'number'} />
                </FormControl>
              </FormItem>
            )}
          />
        </div>
        <FormField
          control={form.control}
          name="file"
          render={({ field }) => (
            <FormItem className="px-5">
              <FormControl>
                <ControlledFileInput
                  required
                  multiple
                  placeholder="Drag and drop or browse"
                  types={[FileTypeEnum.IMAGE, FileTypeEnum.PDF]}
                  icon={ImageIcon}
                  previewOnClick
                  label={'Upload document'}
                  files={field?.value ? [field?.value] : undefined}
                  onFilesChange={(files) => {
                    field.onChange(files.length === 0 ? null : files[0])
                  }}
                />
              </FormControl>
            </FormItem>
          )}
        />
        <ValidationButtons {...validationButtonProps} hasBorderTop />
      </form>
    </Form>
  )
}

export default TeflDiplomaForm
